import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { Help } from '../../constants'
import { Entity } from '../../types'

const CreateEditFormItems: React.FC<Entity> = ({ entity }) => {
  return (
    <>
      <CIMSFormItem
        label="Label"
        requiredMessage="Please enter a label"
        name="label"
        help={Help.Label(entity)}
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem label="Reference" name="href" help={Help.Reference} url>
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        label="Description"
        name="description"
        help={Help.Description}
      >
        <Input />
      </CIMSFormItem>
    </>
  )
}

export default CreateEditFormItems
